import React from "react";

const About = () => {
  return (
    <section className="section about-section">
      <h2 className="section-title">about us</h2>
      <p>Hi welcom to my cocktail intro site! Enjoy yourself!</p>
    </section>
  );
};

export default About;
